module.exports = __webpack_public_path__ + "static/favicon-f210bf2f0cec2ae13ba3e354f7634a69.ico";